export default __webpack_public_path__ + "static/media/world_map.3431e3ed.png";